import { customGet, customPost } from "../../api/customApi";
import entityType from "../../api/entityType";
import { Actions } from "./renewalConstants";
export const listReminderProfiles = (values) => async (dispatch) => {
  dispatch({ type: Actions.LIST_REMINDER_PROFILES });

  const payload = await customPost(
    entityType.RENEWAL,
    "ListReminderProfiles",
    values
  );
  dispatch({ type: Actions.LIST_REMINDER_PROFILES_SUCCEEDED, payload });
};

const transformSearchValues = (values, returnProducerLists, getState) => {
  if (values == null) return null;
  let transformedValues = values;

  // Transform agency keys
  if (values.AgencyKeys == [0]) {
    const state = getState();
    const agencies = state.agency.listCompact;
    transformedValues = {
      ...transformedValues,
      AgencyKeys: !agencies ? [] : agencies.map((a) => a.Id),
    };
  }

  // Transform reminder profile Ids
  if (values.ReminderProfileIds == [0]) {
    const state = getState();
    const profiles = state.renewal.reminderProfiles;
    transformedValues = {
      ...transformedValues,
      ReminderProfileIds: !profiles ? [] : profiles.map((p) => p.value),
    };
  }

  // Format policy status
  let policyStatus = "";
  if (values.PolicyStatusActive === true) {
    policyStatus = "A";
  }
  if (values.PolicyStatusExpired === true) {
    policyStatus = policyStatus + (policyStatus.length > 0 ? "," : "") + "E";
  }
  if (values.PolicyStatusCancelled === true) {
    policyStatus = policyStatus + (policyStatus.length > 0 ? "," : "") + "C";
  }
  if (values.PolicyStatusRenewed === true) {
    policyStatus = policyStatus + (policyStatus.length > 0 ? "," : "") + "R";
  }

  if (values.PolicyStatusLost === true) {
    policyStatus = policyStatus + (policyStatus.length > 0 ? "," : "") + "L";
  }
  transformedValues = {
    ...values,
    ReturnProducerLists: returnProducerLists,
    PolicyStatus: policyStatus.length > 0 ? policyStatus : "A",
  };
  return transformedValues;
};

export const listRenewals =
  (values, returnProducerLists) => async (dispatch, getState) => {
    const searchValues = transformSearchValues(values, returnProducerLists, getState);
    dispatch({ type: Actions.LIST_RENEWALS });

    // Dispatch search values first
    dispatch({
      type: Actions.SET_SEARCH_VALUES,
      payload: { searchValues: values }, // Store original values, not transformed
    });

    let payload = await customPost(
      entityType.RENEWAL,
      "List",
      searchValues
    );

    payload = { ...payload, returnProducerLists };

    dispatch({
      type: Actions.LIST_RENEWALS_SUCCEEDED,
      payload,
    });
  };

export const listAssignees = (renewalKeys) => async (dispatch) => {
  dispatch({ type: Actions.LIST_ASSIGNEES });

  const payload = await customPost(
    entityType.RENEWAL,
    "ListAssignees",
    { RenewalKeys: renewalKeys }
  );

  dispatch({ type: Actions.LIST_ASSIGNEES_SUCCEEDED, payload });
};

export const listProducerCodes = (renewalKeys, producerSlot) => async (dispatch) => {
  dispatch({ type: Actions.LIST_PRODUCER_CODES, payload: { producerSlot } });

  const payload = await customPost(
    entityType.RENEWAL,
    "ListProducerCodes",
    {
      RenewalKeys: renewalKeys,
      CodeNumber: producerSlot,
    }
  );

  dispatch({type: Actions.LIST_PRODUCER_CODES_SUCCEEDED, payload, meta: { producerSlot }});
};

export const clearSelectedRenewalRows = () => async (dispatch) => {
  dispatch({
    type: Actions.CLEAR_SELECTED_ROWS,
  });
};

export const setSelectedRenewalRows = (values) => async (dispatch) => {
  dispatch({
    type: Actions.SET_SELECTED_ROWS,
    payload: { selectedRows: values },
  });
};

export const read = (renewalKey, action) => async (dispatch) => {
  dispatch({ type: Actions.READ_RENEWAL_DETAILS });
  const payload = await customGet(entityType.RENEWAL, "Read", {
    params: {
      renewalKey: renewalKey,
    },
  });
  dispatch({ type: Actions.READ_RENEWAL_DETAILS_SUCCEEDED, payload });
  if (action != null) {
    action();
  }
};

export const setActiveRenewalTab = (tabKey) => ({
  type: Actions.SET_ACTIVE_TAB,
  payload: { tabKey: tabKey },
});

export const bulkAssignRenewals = (renewalKeys, assigneeUserKey) => async (dispatch) => {
  dispatch({ type: Actions.BULK_ASSIGN_RENEWALS });

  const payload = await customPost(
    entityType.RENEWAL,
    "BulkAssign",
    {
      RenewalKeys: renewalKeys,
      AssigneeUserKey: assigneeUserKey,
    }
  );

  dispatch({ type: Actions.BULK_ASSIGN_RENEWALS_SUCCEEDED, payload });
};

export const bulkUpdateProducerCode = (renewalKeys, producerSlot, producerCodeKey) => async (dispatch) => {
  dispatch({ type: Actions.BULK_UPDATE_PRODUCER_CODE, payload: { producerSlot }});

  const payload = await customPost(
    entityType.RENEWAL,
    "BulkUpdateProducerCode",
    {
      RenewalKeys: renewalKeys,
      CodeNumber: producerSlot,
      ProducerCodeKey: producerCodeKey,
    }
  );

  dispatch({ type: Actions.BULK_UPDATE_PRODUCER_CODE_SUCCEEDED, payload, meta: { producerSlot }});
};

export const clearReminderProfiles = () => ({
  type: Actions.CLEAR_REMINDER_PROFILES,
});

export const clearRenewalList = () => ({
  type: Actions.CLEAR_RENEWAL_LIST,
});

export const clearOperationResult = () => async (dispatch) => {
  dispatch({ type: Actions.CLEAR_OPERATION_RESULT });
};

export const clearBulkAssignData = () => ({
  type: Actions.CLEAR_BULK_ASSIGN_DATA,
});

export const clearBulkProducerUpdateData = (producerSlot) => ({
  type: Actions.CLEAR_BULK_PRODUCER_UPDATE_DATA,
  payload: { producerSlot },
});

export const clearBulkProducerTargets = (producerSlot) => ({
  type: Actions.CLEAR_BULK_PRODUCER_TARGETS,
  payload: { producerSlot },
});

export const clearProducerSlotState = (slot) => (dispatch) => {
  dispatch(clearBulkProducerUpdateData(slot));
  dispatch(clearBulkProducerTargets(slot));
};

// ── Reminder Preferences ──

export const readReminderPreferences = (renewalKey) => async (dispatch) => {
  dispatch({ type: Actions.READ_REMINDER_PREFERENCES });

  const payload = await customGet(entityType.RENEWAL, "GetRenewalReminderPreferences", {
    params: {
      renewalKey: renewalKey,
    },
  });

  dispatch({ type: Actions.READ_REMINDER_PREFERENCES_SUCCEEDED, payload });
};

export const listReminderPreferenceChangeReasons = () => async (dispatch) => {
  dispatch({ type: Actions.LIST_REMINDER_PREFERENCE_CHANGE_REASONS });

  const payload = await customGet(
    entityType.RENEWAL,
    "ListRenewalReminderPreferenceChangeReasons"
  );

  dispatch({
    type: Actions.LIST_REMINDER_PREFERENCE_CHANGE_REASONS_SUCCEEDED,
    payload,
  });
};

// Reference data changes very rarely, so only fetch it once per session.
export const listReminderPreferenceStatuses = () => async (dispatch, getState) => {
  const { preferenceStatuses, preferenceStatusesLoading } = getState().renewal;
  if ((preferenceStatuses && preferenceStatuses.length > 0) || preferenceStatusesLoading) {
    return;
  }

  dispatch({ type: Actions.LIST_REMINDER_PREFERENCE_STATUSES });

  const payload = await customGet(
    entityType.RENEWAL,
    "ListRenewalReminderPreferenceStatuses"
  );

  dispatch({
    type: Actions.LIST_REMINDER_PREFERENCE_STATUSES_SUCCEEDED,
    payload,
  });
};

export const updateReminderPreferences = (values) => async (dispatch) => {
  dispatch({ type: Actions.UPDATE_REMINDER_PREFERENCES });

  const payload = await customPost(
    entityType.RENEWAL,
    "UpdateRenewalReminderPreferences",
    values
  );

  dispatch({ type: Actions.UPDATE_REMINDER_PREFERENCES_SUCCEEDED, payload });
};

export const clearReminderPreferencesOperationResult = () => async (dispatch) => {
  dispatch({ type: Actions.CLEAR_REMINDER_PREFERENCES_OPERATION_RESULT });
};

